import { Routes, Route } from "react-router-dom";
import "./App.css";
import Dashboard from "./components/Dashboard";
import { ThemeProvider } from "./components/ThemeContext";
import Enquire from "./pages/Enquire";
import "country-flag-icons/react/3x2";
import Login from "./pages/Login";
import { ToastContainer } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import Kanban from "./pages/Kanban";
import DataCenter from "./pages/DataCenter";
import Insights from "./pages/insights";
import Analytics from "./pages/analytics";
// import Setting from "./pages/Setting";

function App() {
  return (
    <ThemeProvider>
      <Routes>
        <Route path="/" element={<Login />} />
        <Route path="/dashboard" element={<Dashboard />} />
        <Route path="/enquire" element={<Enquire />} />
        <Route path="/kanban" element={<Kanban />} />
         <Route path="/datacenter" element={<DataCenter />} />
         <Route path="/insights" element={<Insights />} />
         <Route path="/analytics" element={<Analytics />} />
        {/* <Route path="/setting" element={<Setting />} /> */}
      </Routes>
      <ToastContainer />
    </ThemeProvider>
  );
}

export default App;
